import { createSlice  } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "sort",
  initialState: {
    selected: "",
    options: [
      { name: "All", value: ""},
      { name: "Most recent", value: "most_recent"},
      { name: "Oldest", value: "oldest"},
      { name: "With review", value: "with_review"},
      { name: "Without review", value: "without_review"},
    ]
  },
  reducers: {
    sortUpdated: (size, action) => {
      size.selected = action.payload;
    }
  }
});

export const { sortUpdated } = slice.actions;
export default slice.reducer;
